import { render, staticRenderFns } from "./leads-table.vue?vue&type=template&id=f79697ee&scoped=true"
import script from "./leads-table.vue?vue&type=script&lang=js"
export * from "./leads-table.vue?vue&type=script&lang=js"
import style0 from "./leads-table.vue?vue&type=style&index=0&id=f79697ee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79697ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f79697ee')) {
      api.createRecord('f79697ee', component.options)
    } else {
      api.reload('f79697ee', component.options)
    }
    module.hot.accept("./leads-table.vue?vue&type=template&id=f79697ee&scoped=true", function () {
      api.rerender('f79697ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/modules/leads/components/tables/leads-table.vue"
export default component.exports